module.exports = ".myblock {\n    background-color: green;\n    width: 300px;\n    height: 200px;\n    border-radius: 5px;\n    margin: 5rem;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dant/dant.component.css
// module id = ./src/app/dant/dant.component.css
// module chunks = main